import React from 'react';

import { __ } from '@wordpress/i18n'; 

const getImageUrl = () => {
    if (typeof window.thhaAdminSettings !== 'undefined' && window.thhaAdminSettings.assets_url) {
        return window.thhaAdminSettings.assets_url + 'img/welcome.jpg';
    }
    return 'none'; 
};

const WelcomeSection = () => {
    const handleCreateNewPage = (e) => {
        e.preventDefault();
        
        // Basic validation: Ensure wpApiSettings is available (standard in WP admin)
        if (typeof window.wpApiSettings === 'undefined') {
            console.error('wpApiSettings not available. Ensure your script is enqueued in the admin with wp_localize_script.');
            return;
        }

        // Create a new draft page via WP REST API
        fetch(`${window.wpApiSettings.root}wp/v2/pages`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.wpApiSettings.nonce,  // Auth nonce for REST API
            },
            body: JSON.stringify({
                title: __('New Page', 'huge-addons-for-elementor'),  // Or customize title
                status: 'draft',  // Starts as draft
                // Optional: Add content or other fields if needed
            }),
        })
        .then((res) => {
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then((newPage) => {
            // Redirect to Elementor editor for the new page
            const editUrl = `post.php?post=${newPage.id}&action=elementor`;
            window.location.href = editUrl;
        })
        .catch((error) => {
            console.error('Error creating new page:', error);
            if (typeof window.iziToast !== 'undefined') {
                window.iziToast.error({
                    title: 'ERROR',
                    message: __('Failed to create new page. Please try again.', 'huge-addons-for-elementor'),
                    position: 'topCenter',
                    timeout: 5000,
                });
            }
        });
    };
    
    return (
        <div className='welcome-widget-container' >
            <div className='welcome-widget-content'>
                <h1 className='welcome-widget-title' >{__('Welcome To Huge Addons', 'huge-addons-for-elementor')}</h1>
                <p className='welcome-widget-description'>
                   {__('We designed huge addons to be intuitive but we do recommend learning how it works by checking our comprehensive documentation and watching the video below. Enjoy your time with Huge Addons!', 'huge-addons-for-elementor')}
                </p>
                <div className="button-container" >
                    <a 
                        href="#" 
                        className="create-new-page" 
                        onClick={handleCreateNewPage}
                    >
                        <span aria-hidden="true" className='thha-icon thha-icon-plus-sign w22 h22'></span>{__('Create New Page', 'huge-addons-for-elementor')}
                    </a>
                    <a href="#" className="guide-link" >
                        {__('Read Full Guide', 'huge-addons-for-elementor')}
                       <span className='thha-icon thha-icon-externel-link w16 h16'></span>
                    </a>
                </div>
            </div>
            
            <div className="image-placeholder"  style={{backgroundImage: `url(${getImageUrl()})`}}>
            </div>
        </div>
    );
};

export default WelcomeSection;